import React, { FC } from 'react';
import Link from '@/components/atoms/link';
import Image from '@/components/atoms/Image';

export interface Props {
  logo: any;
  logoLink: any;
  imageClassName?: string;
  onClick?: () => void;
}

const HeaderLogo: FC<Props> = ({ logoLink, logo, imageClassName, onClick }) => {
  // Removed usePreloadImages hook for better performance - it was waiting for window.load event
  return (
    <div className="relative md:mt-0" onClick={onClick}>
      <Link className={imageClassName} link={logoLink}>
        <Image
          src={logo}
          alt={""}
          fill
          style={{ objectFit: 'contain' }}
          priority
          loading="eager"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
      </Link>
    </div>
  );
};

export default HeaderLogo;
